import { combineReducers } from "redux";

import { shopReducer } from "../reducers/shopReducer";
import cartReducer from "../reducers/cartReducer";
import orderReducer from "../reducers/orderReducer";
import { store } from "../components/store";

export const rootReducer = combineReducers({
  shop: shopReducer,
  cart: cartReducer,
  order: orderReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
